import React from 'react';
import { Construction } from 'lucide-react';

interface PlaceholderProps {
  title: string;
  description?: string;
}

export const Placeholder: React.FC<PlaceholderProps> = ({ title, description }) => {
  return (
    <div className="min-h-screen bg-ncaa-light flex items-center justify-center">
      <div className="max-w-md mx-auto text-center p-8">
        <div className="w-24 h-24 bg-ncaa-primary rounded-full flex items-center justify-center mx-auto mb-6">
          <Construction className="h-12 w-12 text-white" />
        </div>
        <h1 className="text-3xl font-bold text-ncaa-dark mb-4">{title}</h1>
        <p className="text-ncaa-medium mb-8">
          {description || 'This page is coming soon as part of Phase 2 development.'}
        </p>
        <div className="bg-white rounded-lg p-4 border border-gray-200">
          <p className="text-sm text-gray-600">
            Phase 1 Setup Complete ✅<br />
            This component will be implemented in the next development phase.
          </p>
        </div>
      </div>
    </div>
  );
};
